var _defs, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSapIconSquare = function SvgSapIconSquare(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "sap-icon-square_svg__Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 40 40"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "sap-icon-square_svg__linear-gradient",
    x1: 18.5,
    y1: 31,
    x2: 18.5,
    y2: 13.2,
    gradientTransform: "matrix(1 0 0 -1 0 42)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0ae"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#05a"
  })), /*#__PURE__*/React.createElement("style", null, ".sap-icon-square_svg__st1{fill:#fff}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "sap-icon-square_svg__st1",
    d: "M0 0h40v40H0z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M37 11H0v17.8h19.2",
    style: {
      fill: "url(#sap-icon-square_svg__linear-gradient)"
    }
  }), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "sap-icon-square_svg__st1",
    d: "M18.8 14.5v8.4l-3.1-8.4h-3.1l-2.6 7c-.3-1.7-2.1-2.4-3.6-2.8-.9-.3-2-.7-2-1.3s.6-.8 1.6-.7c.7 0 1.3 0 2.6.7l1.3-2.1c-1.2-.6-2.8-.9-4-.9s-2.8.5-3.6 1.3c-.6.6-.8 1.3-.9 2.1 0 1.1.4 1.9 1.3 2.5.7.5 1.6.8 2.4 1 1 .3 1.8.6 1.8 1.2 0 .7-.9.9-1.4.9-.9 0-1.7 0-2.9-.8l-1.1 2.1c1.2.7 2.5 1 4 1s2.6-.3 3.5-1.1l-.2.7h3l.6-1.3c1.2.3 2.5.4 3.7 0l.4 1.3h5.4v-3.2H23c2.8 0 4.4-1.3 4.4-3.7s-1.6-3.8-5-3.8h-3.6Zm-5.8 7 1.1-3.6 1.1 3.6c-.8.2-1.6.2-2.3 0Zm8.8-1.8v-2.8h.8c1 0 1.8.3 1.8 1.3s-.8 1.5-1.8 1.5h-.8Z"
  })));
};
export default SvgSapIconSquare;